var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconUpcomingEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fill: "#3E424E",
    d: "M15 28.334h23.333v18.333H15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 10.317H10c-3.682 0-6.667 3.127-6.667 6.985v52.38c0 3.858 2.985 6.985 6.667 6.985h60c3.682 0 6.667-3.127 6.667-6.984V17.3c0-3.857-2.985-6.984-6.667-6.984z",
    stroke: "#3E424E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.333 3.333v13.969M56.666 3.333v13.969",
    stroke: "#3E424E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3E424E",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    d: "M15 28.334h23.333v18.333H15z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUpcomingEmpty);
export default __webpack_public_path__ + "static/media/icon-upcoming-empty.283657bda654f9176b5eee5415365faa.svg";
export { ForwardRef as ReactComponent };